<script lang="ts">
  import { setContext } from 'svelte';
  import clsx from 'clsx';
  import type { HTMLAttributes } from 'svelte/elements';
  import { gridContextKey, type GridContext, type GridProps } from './types';
  import { getGapClassName } from './utils';

  let {
    children,
    class: className,
    space = 'gutter',
    columns,
    action = () => undefined,
    actionArg,
    ...restProps
  }: GridProps & Omit<HTMLAttributes<HTMLDivElement>, 'class'> = $props();

  const context: GridContext = {
    space: () => space,
    columns: () => columns,
    renderedItems: 0,
  };
  setContext(gridContextKey, context);

  // See comment in types.ts:gridColumnSpans.default why we use a 2 column grid
  // for small screens
  const gridClasses = 'grid grid-cols-2 md:grid-cols-12';

  function elementAction(node: HTMLDivElement) {
    if (action) {
      return action(node, actionArg!);
    }
  }
</script>

<div {...restProps} use:elementAction class={clsx(gridClasses, className, getGapClassName(space))}>
  {@render children()}
</div>
